import { render } from "./DocumentArchiveCreate.vue?vue&type=template&id=fc63f856&ts=true"
import script from "./DocumentArchiveCreate.vue?vue&type=script&lang=ts"
export * from "./DocumentArchiveCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__